var render = function () {
  var _vm$brand$thumbnail, _vm$brand$thumbnail2, _vm$brand$thumbnail3, _vm$brand$thumbnail4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "brand-el",
    class: [("brand-el__size-" + (_vm.size))]
  }, [_c('nuxt-link', {
    staticClass: "brand-el__wrap",
    attrs: {
      "to": ("/brands/" + (_vm.brand.code || _vm.brand.id) + "/"),
      "title": _vm.brand.name
    }
  }, [_vm.photoLazyload ? [_c('LazyImg', {
    staticClass: "brand-el__img",
    attrs: {
      "img": (_vm$brand$thumbnail = _vm.brand.thumbnail) === null || _vm$brand$thumbnail === void 0 ? void 0 : _vm$brand$thumbnail.x1,
      "srcset": (_vm$brand$thumbnail2 = _vm.brand.thumbnail) === null || _vm$brand$thumbnail2 === void 0 ? void 0 : _vm$brand$thumbnail2.x2,
      "alt": _vm.brand.name
    }
  })] : _c('img', {
    staticClass: "brand-el__img",
    attrs: {
      "src": (_vm$brand$thumbnail3 = _vm.brand.thumbnail) === null || _vm$brand$thumbnail3 === void 0 ? void 0 : _vm$brand$thumbnail3.x1,
      "srcset": (((_vm$brand$thumbnail4 = _vm.brand.thumbnail) === null || _vm$brand$thumbnail4 === void 0 ? void 0 : _vm$brand$thumbnail4.x2) + " 2x"),
      "alt": _vm.brand.name
    }
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }